module.exports = __webpack_public_path__ + "img/makinormalvogelperspektive.36c5505b.jpg";